import React, { useState, useEffect, useRef } from "react";
import './checkride.css';
import {
    Grid,
    Button,
    TextField
} from "@material-ui/core";
import { Link, useHistory, useParams } from "react-router-dom";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { helpers } from "../../../helpers";

/** Local deoendencies & Libraries */
import Services from '../../../Services';
import DynamicInput from "../../../Components/InputComponents/DynamicInput";
import DynamicFormFields from "../../../Components/InputComponents/DynamicFormFields";
import { checkRideKeyNames, IncidentDropdowns, IncidentFormFields, incidentTypesOptions, list_checkride_type, tgsLocation, TODIncident, visibiltyIncident } from "../../../Components/TableComponents/constants";
import { Form, Input, message, Select, Spin, Switch, Tabs } from 'antd';

import { Cancel } from "@material-ui/icons";
import { Autocomplete } from "@mui/material";
import { TempleBuddhist } from "@mui/icons-material";
import { LabelIncident, validateLatLong, validateRulesBroken } from "../../../helpers/textValidation";
import moment from "moment-timezone";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";
const { TextArea } = Input;
const {
    employee,
    Storage, hr
} = Services;

const { FRA_OSHA, CauseTypes, OpenClosed, DirectionOfTravel, MoveTypes } = IncidentDropdowns



const EnterIncident = () => {

    let { id } = useParams()



    const storage = new Storage();
    // const currentUser = JSON.parse(storage.get('user_profile'))

    const [IncidentByID, setIncidentByID] = useState({})
    const [empty, setEmpty] = useState(true)

    const [formFields, setFormFields] = useState({
        DrugAlcoholTest: false,
        PicturesTaken: false,
        Injury: false,
        HumanFailure: false,
        FatigueAFactor: false,
        SupervisorNotified: false,
        RailIncident: false,
        RuleViolation: false,
        IncidentDate: new Date(),
        IncidentTime: moment(new Date()).format("hh:mm:ss"),
    });
    const [approve, setApprove] = useState(false)
    const [listings, setListings] = useState({})
    const [empInvolvedInIncident, setEmpInvolvedInIncident] = useState([{ Name: null, Position: null, Hired6Months: false, Notes: null }])
    const [enableButton, setEnableButton] = useState()



    const generalHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const generalInfoHOC = (value, key) => {
        if (key === 'department') fetchSubDepartments(value)
        if (key === 'RulesBroken' && !validateRulesBroken(value)) return
        if (key === 'IncidentTypeId') fetchClassifications(value?.id)
        setFormFields({ ...formFields, [key]: value })
    }

    const locationHOC = (value, key) => {
        if (['Latitude', 'Longitude'].includes(key) && !validateLatLong(value)) return
        setFormFields({ ...formFields, [key]: value })
    }

    const approverHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const rGeneralHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const rMovementHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const rCrewHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const rRerailHOC = (value, key) => {
        setFormFields({ ...formFields, [key]: value })
    }

    const addEmployeeInvolvedHOC = (value, key, i) => {

        let tempArr = empInvolvedInIncident
        tempArr[i][key] = value
        if (key === "Name") {
            tempArr[i].EmployeeId = value?.id
            tempArr[i][key] = value?.firstName
        }
        setEmpInvolvedInIncident(prev => prev = tempArr)
    }

    const fetchData = async () => {

        const promises = [
            employee.get_site_listing(),
            hr.department(),
            employee.get_employee_listing_not_Terminated(),
            hr.getIncidentTypes(),
        ]
        const [res1, res2, res3, res4] = await Promise.all(promises)
        setListings({ ...listings, locations: res1?.data, department: res2.data, employees: res3.data, types: res4.data })

    }

    const fetchSubDepartments = async (value) => {
        let response = await hr.subDepartment(value)
        if (response.httpStatus === 200) setListings({ ...listings, subdepartment: response?.data })
    }

    const fetchClassifications = async (value) => {
        let response = await hr?.getClassifications(value)
        if (response.httpStatus === 200) setListings({ ...listings, classification: response?.data })
    }

    const fetchIncidentByID = async (id) => {
        let res = await hr.incidentFieldsByID(id)
        if (res?.httpStatus === 200) {

            setEmpty(prev => { return prev = false })
            const [Visibility] = visibiltyIncident?.filter(x => x?.title === res?.data?.Visibility)
            const [travelDirection] = IncidentDropdowns?.DirectionOfTravel?.filter(x => x?.title === res?.data?.RailIncidents[0]?.travelDirection)
            const [moveType] = IncidentDropdowns?.MoveTypes?.filter(x => x?.title === res?.data?.RailIncidents[0]?.moveType)
            const [TimeOfDay] = TODIncident?.filter(x => x?.title === res?.data?.TimeOfDay)

            //  
            let empArr = res
                ?.data
                ?.InvolvedEmployees
                ?.map((data) => ({ Name: { ...data, firstName: data?.Name }, Position: data?.Position, Hired6Months: data?.Hired6Months, Notes: data?.Notes }))
            setEmpInvolvedInIncident([])
            setTimeout(() => {
                setFormFields(prev =>
                    prev = {
                        ...res?.data,
                        LocationId: {
                            id: res?.data?.TGSLocation?.id,
                            title: (res?.data?.TGSLocation?.name)?.toString()
                        },
                        Temperature: res?.data?.Temperature?.toString(),
                        department: { id: res?.data?.SubDepartment?.Department?.id, title: res?.data?.SubDepartment?.Department?.name },
                        SubDepartmentId: { id: res?.data?.SubDepartment?.id, title: res?.data?.SubDepartment?.name },
                        IncidentTypeId: { id: res?.data?.IncidentType?.id, Type: res?.data?.IncidentType?.Type },
                        Visibility,
                        TimeOfDay,
                        travelDirection,
                        moveType

                    })
                setEmpInvolvedInIncident(prev => { return prev = empArr })
                setEmpty(prev => { return prev = true })
            }, 0);
        }
        // setIncidentByID(res?.data[0])
    }

    useEffect(() => {
        fetchData()
        if (id)
            fetchIncidentByID(id)
    }, [])


    let fields = IncidentFormFields(formFields, listings, empInvolvedInIncident)


    const getEmpValue = (i, key) => empInvolvedInIncident[i][key]

    const removeCrew = (index) => {
        let tempArr = []
        tempArr = empInvolvedInIncident
        tempArr.splice(index, 1)
        setEmpInvolvedInIncident([])
        setTimeout(() => {
            setEmpInvolvedInIncident(prev => { return prev = tempArr })
        }, 0);
    };

    const addCrew = () => {
        setEmpInvolvedInIncident(prev => ([...prev, { Name: "", Position: null, Hired6Months: false, Notes: null }]))
    }






    const onSave = async () => {

        let body = {
            ...formFields,
            employeesInvolved: empInvolvedInIncident,
            LocationId: formFields?.LocationId?.id,
            IncidentTypeId: formFields?.IncidentTypeId?.id,
            SubDepartmentId: formFields?.SubDepartmentId?.id,
            ClassificationId: formFields?.ClassificationId?.id,
            TimeOfDay: formFields?.TimeOfDay?.title,
            Visibility: formFields?.Visibility?.title,
            moveType: formFields?.moveType?.title,
            travelDirection: formFields?.travelDirection?.title,
            RailIncidentData: {
                JobId: formFields?.JobId,
                totalCars: formFields?.totalCars,
                Loads: formFields?.Loads,
                Empties: formFields?.Empties,
                ApparentCause: formFields?.ApparentCause,
                TotalHAZMATCars: formFields?.TotalHAZMATCars,
                HAZMATCarsDerailOrDamaged: formFields?.HAZMATCarsDerailOrDamaged,
                HAZMATCarsReleasedOrSpilled: formFields?.HAZMATCarsReleasedOrSpilled,
                locomotiveNum: formFields?.locomotiveNum,
                RailcarEquipNums: formFields?.RailcarEquipNums,
                employeesNotified: formFields?.employeesNotified,
                notifiedDate: formFields?.notifiedDate,
                notifiedTime: formFields?.notifiedTime,
                approxSpeed: formFields?.approxSpeed,
                travelDirection: formFields?.travelDirection?.title,
                moveType: formFields?.moveType?.title,
                HoursOnDuty: formFields?.HoursOnDuty,
                CrewLocationAtIncident: formFields?.CrewLocationAtIncident,
                CrewActivityAtIncident: formFields?.CrewActivityAtIncident,
                rerailingCrewName: formFields?.rerailingCrewName,
                rerailMethod: formFields?.rerailMethod,
                timeCalled: formFields?.timeCalled,
                timeArrived: formFields?.timeArrived,
                timeReleased: formFields?.timeReleased,
            },
        }
        delete body?.JobId
        delete body?.totalCars
        delete body?.Loads
        delete body?.Empties
        delete body?.ApparentCause
        delete body?.TotalHAZMATCars
        delete body?.HAZMATCarsDerailOrDamaged
        delete body?.HAZMATCarsReleasedOrSpilled
        delete body?.locomotiveNum
        delete body?.RailcarEquipNums
        delete body?.employeesNotified
        delete body?.notifiedDate
        delete body?.notifiedTime
        delete body?.approxSpeed
        delete body?.travelDirection
        delete body?.moveType
        delete body?.HoursOnDuty
        delete body?.CrewLocationAtIncident
        delete body?.CrewActivityAtIncident
        delete body?.rerailingCrewName
        delete body?.rerailMethod
        delete body?.timeCalled
        delete body?.timeArrived
        delete body?.timeReleased
        delete body?.department

        let res = await hr?.createIncident(body)


    }
    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Incident</Grid>
                {!approve ? <div className="d-flex-column" style={{ marginTop: "20px" }}>
                    <div className="d-flex-colum">
                        <h3 style={{ color: "#2863AD", fontWeight: "bold", marginTop: "20px" }}>Enter New Incident</h3>
                        <div>
                            <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                <DynamicFormFields fields={fields.general} onChange={generalHOC} grid={4} page="incident" />
                            </div>
                            <LabelIncident text={"Location Of Incident"} />
                            {empty && <>
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFields fields={fields.location} onChange={locationHOC} grid={4} page="incident" />
                                </div>
                                <LabelIncident text={"General Information"} />
                                {/* <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    </div> */}
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px", position: "relative" }}>
                                    <DynamicFormFields fields={fields.generalInfo} onChange={generalInfoHOC} grid={4} page="incident" />
                                    <button
                                        onClick={addCrew}
                                        style={{ position: "absolute", right: 0, bottom: 0, padding: "10px", background: "#2963AD", color: "white", border: "none", borderRadius: "10px", cursor: "pointer" }}>+ Add Employee Involved</button>
                                </div>
                                <LabelIncident text={"Employees Involved"} />
                                {/* <div style={{ minHeight: `200px` }}> */}
                                {empInvolvedInIncident?.map((x, i) => <>
                                    <div style={{ display: "grid", gridTemplateColumns: "20% 20% 20% 30% 10%", gap: "15px" }}>
                                        <DynamicFormFields index={i} valueFunc={getEmpValue} fields={fields.employeeInvolved} onChange={(value, key) => addEmployeeInvolvedHOC(value, key, i)} grid={4} page="incident" />

                                        {empInvolvedInIncident?.length > 1 ?
                                            <Button
                                                style={{ minWidth: "20px", maxWidth: "20px", height: "21px", color: "red", borderRadius: "100%" }}
                                                onClick={() => removeCrew(i)}
                                            ><Cancel /></Button>
                                            : <></>}
                                    </div>
                                </>)}
                            </>}
                            {/* </div> */}
                            {formFields.RailIncident && <div style={{ margin: "30px 0" }}>
                                <h3 style={{ color: "#2863AD", fontWeight: "bold" }}>Rail Incident Data</h3>
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFields fields={fields.railRoad.general} onChange={rGeneralHOC} grid={4} page="incident" />
                                </div>
                                <LabelIncident text={"Movement Information"} />
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFields fields={fields.railRoad.movement} onChange={rMovementHOC} grid={4} page="incident" />
                                </div>
                                <LabelIncident text={"Crew Information"} />
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFields fields={fields.railRoad.crew} onChange={rCrewHOC} grid={4} page="incident" />
                                </div>
                                <LabelIncident text={"Re-Railing Information"} />
                                <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFields fields={fields.railRoad.rerail} onChange={rRerailHOC} grid={4} page="incident" />
                                </div>
                            </div>}

                        </div>
                    </div>
                </div> : <div style={{ margin: "30px 0" }}>
                    <h3 style={{ color: "#2863AD", fontWeight: "bold" }}>Approver Information</h3>
                    <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                        <DynamicFormFields fields={fields.approver} onChange={approverHOC} grid={4} page="incident" />
                    </div>
                </div>}
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: approve ? "" : "50px" }}>
                    <Button className="LinkButton" onClick={onSave}>{approve ? "Finalize Incident" : "Save"}</Button>
                </div>

            </Grid>
        </PageLayout>
    );
}

export default EnterIncident;


